// GENERATED FILE, PLEASE DO NOT EDIT
export var BackgroundPrimary = '#ffffff';
export var BackgroundPrimaryInverted = '#191919';
export var BackgroundSecondary = '#F7F7F7';
export var BackgroundSecondaryInverted = '#313131';
export var BackgroundTertiary = '#E7E7E7';
export var BackgroundElevated = '#ffffff';
export var BackgroundOverlay = '#191919';
export var BannerDefaultBackground = '#F7F7F7';
export var BannerDefaultForeground = '#191919';
export var BannerDefaultIcon = '#191919';
export var BannerHighlightBackground = '#ECFCFC';
export var BannerHighlightForeground = '#191919';
export var BannerHighlightIcon = '#00666D';
export var BannerInformationalBackground = '#494949';
export var BannerInformationalForeground = '#ffffff';
export var BannerInformationalIcon = '#ffffff';
export var BannerNegativeBackground = '#FFF0ED';
export var BannerNegativeForeground = '#191919';
export var BannerNegativeIcon = '#B71000';
export var BannerPositiveBackground = '#E7FBEF';
export var BannerPositiveForeground = '#191919';
export var BannerPositiveIcon = '#00872F';
export var BannerWarningBackground = '#FFFFA3';
export var BannerWarningForeground = '#191919';
export var BannerWarningIcon = '#D5A600';
export var BorderPrimary = '#E7E7E7';
export var BorderSecondary = '#D6D6D6';
export var ButtonDefaultForeground = '#ffffff';
export var ButtonDefaultForegroundDisabled = '#ffffff';
export var ButtonDefaultForegroundHovered = '#ffffff';
export var ButtonDefaultForegroundPressed = '#ffffff';
export var ButtonDefaultToggleForeground = '#ffffff';
export var ButtonDefaultToggleForegroundDisabled = '#C4C4C4';
export var ButtonDefaultToggleForegroundHovered = '#ffffff';
export var ButtonDefaultToggleForegroundOff = '#191919';
export var ButtonDefaultToggleForegroundOffDisabled = '#8B8B8B';
export var ButtonDefaultToggleForegroundOffHovered = '#191919';
export var ButtonDefaultToggleForegroundOffPressed = '#191919';
export var ButtonDefaultToggleForegroundPressed = '#ffffff';
export var ButtonFabBackground = '#ffffff';
export var ButtonFabBackgroundDisabled = '#ffffff';
export var ButtonFabBackgroundHovered = '#F7F7F7';
export var ButtonFabBackgroundPressed = '#E7E7E7';
export var ButtonFabForeground = '#191919';
export var ButtonFabForegroundDisabled = '#B2B2B2';
export var ButtonFabForegroundHovered = '#191919';
export var ButtonFabForegroundPressed = '#191919';
export var ButtonFlatPrimaryBackground = '#ffffff';
export var ButtonFlatPrimaryBackgroundHovered = '#E7E7E7';
export var ButtonFlatPrimaryBackgroundPressed = '#E7E7E7';
export var ButtonFlatPrimaryForeground = '#EB1700';
export var ButtonFlatPrimaryForegroundDisabled = '#B2B2B2';
export var ButtonFlatPrimaryForegroundHovered = '#D91400';
export var ButtonFlatPrimaryForegroundPressed = '#B71000';
export var ButtonFlatSecondaryBackground = '#ffffff';
export var ButtonFlatSecondaryBackgroundHovered = '#E7E7E7';
export var ButtonFlatSecondaryBackgroundPressed = '#E7E7E7';
export var ButtonFlatSecondaryForeground = '#191919';
export var ButtonFlatSecondaryForegroundDisabled = '#B2B2B2';
export var ButtonFlatSecondaryForegroundHovered = '#313131';
export var ButtonFlatSecondaryForegroundPressed = '#494949';
export var ButtonPlainBackground = '#ffffff';
export var ButtonPlainBackgroundDisabled = '#ffffff';
export var ButtonPlainBackgroundHovered = '#ffffff';
export var ButtonPlainBackgroundPressed = '#ffffff';
export var ButtonPlainForeground = '#494949';
export var ButtonPlainForegroundDisabled = '#767676';
export var ButtonPlainForegroundHovered = '#494949';
export var ButtonPlainForegroundPressed = '#494949';
export var ButtonPlainToggleBackground = '#ffffff';
export var ButtonPlainToggleBackgroundDisabled = '#ffffff';
export var ButtonPlainToggleBackgroundHovered = '#ffffff';
export var ButtonPlainToggleBackgroundOff = '#ffffff';
export var ButtonPlainToggleBackgroundOffDisabled = '#ffffff';
export var ButtonPlainToggleBackgroundOffHovered = '#ffffff';
export var ButtonPlainToggleBackgroundOffPressed = '#ffffff';
export var ButtonPlainToggleBackgroundPressed = '#ffffff';
export var ButtonPlainToggleForeground = '#494949';
export var ButtonPlainToggleForegroundDisabled = '#767676';
export var ButtonPlainToggleForegroundHovered = '#494949';
export var ButtonPlainToggleForegroundOff = '#494949';
export var ButtonPlainToggleForegroundOffDisabled = '#767676';
export var ButtonPlainToggleForegroundOffHovered = '#494949';
export var ButtonPlainToggleForegroundOffPressed = '#494949';
export var ButtonPlainToggleForegroundPressed = '#494949';
export var ButtonPrimaryBackground = '#EB1700';
export var ButtonPrimaryBackgroundDisabled = '#F7F7F7';
export var ButtonPrimaryBackgroundHovered = '#D91400';
export var ButtonPrimaryBackgroundPressed = '#B71000';
export var ButtonPrimaryForeground = '#ffffff';
export var ButtonPrimaryForegroundDisabled = '#B2B2B2';
export var ButtonPrimaryForegroundHovered = '#ffffff';
export var ButtonPrimaryForegroundPressed = '#ffffff';
export var ButtonPrimaryToggleBackground = '#191919';
export var ButtonPrimaryToggleBackgroundDisabled = '#D6D6D6';
export var ButtonPrimaryToggleBackgroundHovered = '#606060';
export var ButtonPrimaryToggleBackgroundOff = '#E7E7E7';
export var ButtonPrimaryToggleBackgroundOffDisabled = '#F7F7F7';
export var ButtonPrimaryToggleBackgroundOffHovered = '#F7F7F7';
export var ButtonPrimaryToggleBackgroundOffPressed = '#D6D6D6';
export var ButtonPrimaryToggleBackgroundPressed = '#494949';
export var ButtonPrimaryToggleBorderOff = '#E7E7E7';
export var ButtonPrimaryToggleBorderOffHovered = '#F7F7F7';
export var ButtonPrimaryToggleBorderOffPressed = '#D6D6D6';
export var ButtonPrimaryToggleBorderOffDisabled = '#F7F7F7';
export var ButtonPrimaryToggleBorderOn = '#191919';
export var ButtonPrimaryToggleBorderOnHovered = '#606060';
export var ButtonPrimaryToggleBorderOnPressed = '#494949';
export var ButtonPrimaryToggleBorderOnDisabled = '#D6D6D6';
export var ButtonPrimaryToggleForeground = '#ffffff';
export var ButtonPrimaryToggleForegroundDisabled = '#9F9F9F';
export var ButtonPrimaryToggleForegroundHovered = '#ffffff';
export var ButtonPrimaryToggleForegroundOff = '#191919';
export var ButtonPrimaryToggleForegroundOffDisabled = '#B2B2B2';
export var ButtonPrimaryToggleForegroundOffHovered = '#191919';
export var ButtonPrimaryToggleForegroundOffPressed = '#191919';
export var ButtonPrimaryToggleForegroundPressed = '#ffffff';
export var ButtonSecondaryBackground = '#FFF0ED';
export var ButtonSecondaryBackgroundDisabled = '#F7F7F7';
export var ButtonSecondaryBackgroundHovered = '#FFE0DB';
export var ButtonSecondaryBackgroundPressed = '#FEC7BD';
export var ButtonSecondaryForeground = '#D91400';
export var ButtonSecondaryForegroundDisabled = '#B2B2B2';
export var ButtonSecondaryForegroundHovered = '#D91400';
export var ButtonSecondaryForegroundPressed = '#D91400';
export var ButtonSecondaryToggleBackground = '#191919';
export var ButtonSecondaryToggleBackgroundDisabled = '#D6D6D6';
export var ButtonSecondaryToggleBackgroundHovered = '#606060';
export var ButtonSecondaryToggleBackgroundPressed = '#494949';
export var ButtonSecondaryToggleBackgroundOff = '#E7E7E7';
export var ButtonSecondaryToggleBackgroundOffDisabled = '#F7F7F7';
export var ButtonSecondaryToggleBackgroundOffHovered = '#F7F7F7';
export var ButtonSecondaryToggleBackgroundOffPressed = '#D6D6D6';
export var ButtonSecondaryToggleBorderOff = '#E7E7E7';
export var ButtonSecondaryToggleBorderOffHovered = '#F7F7F7';
export var ButtonSecondaryToggleBorderOffPressed = '#D6D6D6';
export var ButtonSecondaryToggleBorderOffDisabled = '#F7F7F7';
export var ButtonSecondaryToggleBorderOn = '#191919';
export var ButtonSecondaryToggleBorderOnHovered = '#606060';
export var ButtonSecondaryToggleBorderOnPressed = '#494949';
export var ButtonSecondaryToggleBorderOnDisabled = '#D6D6D6';
export var ButtonSecondaryToggleForeground = '#ffffff';
export var ButtonSecondaryToggleForegroundDisabled = '#9F9F9F';
export var ButtonSecondaryToggleForegroundHovered = '#ffffff';
export var ButtonSecondaryToggleForegroundPressed = '#ffffff';
export var ButtonSecondaryToggleForegroundOff = '#191919';
export var ButtonSecondaryToggleForegroundOffDisabled = '#B2B2B2';
export var ButtonSecondaryToggleForegroundOffHovered = '#191919';
export var ButtonSecondaryToggleForegroundOffPressed = '#191919';
export var ButtonTertiaryBackground = '#E7E7E7';
export var ButtonTertiaryBackgroundDisabled = '#F7F7F7';
export var ButtonTertiaryBackgroundHovered = '#D6D6D6';
export var ButtonTertiaryBackgroundPressed = '#C4C4C4';
export var ButtonTertiaryBorder = '#E7E7E7';
export var ButtonTertiaryBorderDisabled = '#F7F7F7';
export var ButtonTertiaryBorderHovered = '#D6D6D6';
export var ButtonTertiaryBorderPressed = '#C4C4C4';
export var ButtonTertiaryForeground = '#191919';
export var ButtonTertiaryForegroundDisabled = '#B2B2B2';
export var ButtonTertiaryForegroundHovered = '#191919';
export var ButtonTertiaryForegroundPressed = '#191919';
export var ButtonTertiaryToggleBackground = '#191919';
export var ButtonTertiaryToggleBackgroundDisabled = '#D6D6D6';
export var ButtonTertiaryToggleBackgroundHovered = '#606060';
export var ButtonTertiaryToggleBackgroundOff = '#ffffff';
export var ButtonTertiaryToggleBackgroundOffDisabled = '#F7F7F7';
export var ButtonTertiaryToggleBackgroundOffHovered = '#D6D6D6';
export var ButtonTertiaryToggleBackgroundOffPressed = '#E7E7E7';
export var ButtonTertiaryToggleBackgroundPressed = '#494949';
export var ButtonTertiaryToggleBorderOff = '#191919';
export var ButtonTertiaryToggleBorderOffHovered = '#606060';
export var ButtonTertiaryToggleBorderOffPressed = '#494949';
export var ButtonTertiaryToggleBorderOffDisabled = '#F7F7F7';
export var ButtonTertiaryToggleBorderOn = '#191919';
export var ButtonTertiaryToggleBorderOnHovered = '#606060';
export var ButtonTertiaryToggleBorderOnPressed = '#494949';
export var ButtonTertiaryToggleBorderOnDisabled = '#D6D6D6';
export var ButtonTertiaryToggleForeground = '#ffffff';
export var ButtonTertiaryToggleForegroundDisabled = '#9F9F9F';
export var ButtonTertiaryToggleForegroundHovered = '#ffffff';
export var ButtonTertiaryToggleForegroundPressed = '#ffffff';
export var ButtonTertiaryToggleForegroundOff = '#191919';
export var ButtonTertiaryToggleForegroundOffDisabled = '#B2B2B2';
export var ButtonTertiaryToggleForegroundOffHovered = '#191919';
export var ButtonTertiaryToggleForegroundOffPressed = '#191919';
export var ButtonPrimaryToggleGroupBackgroundOff = '#E7E7E7';
export var ButtonPrimaryToggleGroupBackgroundOffHovered = '#D6D6D6';
export var ButtonPrimaryToggleGroupBackgroundOffPressed = '#D6D6D6';
export var ButtonPrimaryToggleGroupBackgroundOffDisabled = '#F7F7F7';
export var ButtonPrimaryToggleGroupBorderOff = '#E7E7E7';
export var ButtonPrimaryToggleGroupBorderOffHovered = '#D6D6D6';
export var ButtonPrimaryToggleGroupBorderOffPressed = '#D6D6D6';
export var ButtonPrimaryToggleGroupBorderOffDisabled = '#F7F7F7';
export var ButtonPrimaryToggleGroupForegroundOff = '#191919';
export var ButtonPrimaryToggleGroupForegroundOffHovered = '#191919';
export var ButtonPrimaryToggleGroupForegroundOffPressed = '#191919';
export var ButtonPrimaryToggleGroupForegroundOffDisabled = '#B2B2B2';
export var ButtonPrimaryToggleGroupBackgroundOn = '#191919';
export var ButtonPrimaryToggleGroupBackgroundOnHovered = '#606060';
export var ButtonPrimaryToggleGroupBackgroundOnPressed = '#494949';
export var ButtonPrimaryToggleGroupBackgroundOnDisabled = '#D6D6D6';
export var ButtonPrimaryToggleGroupBorderOn = '#191919';
export var ButtonPrimaryToggleGroupBorderOnHovered = '#606060';
export var ButtonPrimaryToggleGroupBorderOnPressed = '#494949';
export var ButtonPrimaryToggleGroupBorderOnDisabled = '#D6D6D6';
export var ButtonPrimaryToggleGroupForegroundOn = '#ffffff';
export var ButtonPrimaryToggleGroupForegroundOnHovered = '#ffffff';
export var ButtonPrimaryToggleGroupForegroundOnPressed = '#ffffff';
export var ButtonPrimaryToggleGroupForegroundOnDisabled = '#9F9F9F';
export var ButtonSecondaryToggleGroupBackgroundOff = '#E7E7E7';
export var ButtonSecondaryToggleGroupBackgroundOffHovered = '#D6D6D6';
export var ButtonSecondaryToggleGroupBackgroundOffPressed = '#D6D6D6';
export var ButtonSecondaryToggleGroupBackgroundOffDisabled = '#F7F7F7';
export var ButtonSecondaryToggleGroupBorderOff = '#E7E7E7';
export var ButtonSecondaryToggleGroupBorderOffHovered = '#D6D6D6';
export var ButtonSecondaryToggleGroupBorderOffPressed = '#D6D6D6';
export var ButtonSecondaryToggleGroupBorderOffDisabled = '#F7F7F7';
export var ButtonSecondaryToggleGroupForegroundOff = '#191919';
export var ButtonSecondaryToggleGroupForegroundOffHovered = '#191919';
export var ButtonSecondaryToggleGroupForegroundOffPressed = '#191919';
export var ButtonSecondaryToggleGroupForegroundOffDisabled = '#B2B2B2';
export var ButtonSecondaryToggleGroupBackgroundOn = '#191919';
export var ButtonSecondaryToggleGroupBackgroundOnHovered = '#606060';
export var ButtonSecondaryToggleGroupBackgroundOnPressed = '#494949';
export var ButtonSecondaryToggleGroupBackgroundOnDisabled = '#D6D6D6';
export var ButtonSecondaryToggleGroupBorderOn = '#191919';
export var ButtonSecondaryToggleGroupBorderOnHovered = '#606060';
export var ButtonSecondaryToggleGroupBorderOnPressed = '#494949';
export var ButtonSecondaryToggleGroupBorderOnDisabled = '#D6D6D6';
export var ButtonSecondaryToggleGroupForegroundOn = '#ffffff';
export var ButtonSecondaryToggleGroupForegroundOnHovered = '#ffffff';
export var ButtonSecondaryToggleGroupForegroundOnPressed = '#ffffff';
export var ButtonSecondaryToggleGroupForegroundOnDisabled = '#9F9F9F';
export var ButtonTertiaryToggleGroupBackgroundOff = '#ffffff';
export var ButtonTertiaryToggleGroupBackgroundOffHovered = '#D6D6D6';
export var ButtonTertiaryToggleGroupBackgroundOffPressed = '#E7E7E7';
export var ButtonTertiaryToggleGroupBackgroundOffDisabled = '#F7F7F7';
export var ButtonTertiaryToggleGroupBorderOff = '#191919';
export var ButtonTertiaryToggleGroupBorderOffHovered = '#606060';
export var ButtonTertiaryToggleGroupBorderOffPressed = '#494949';
export var ButtonTertiaryToggleGroupBorderOffDisabled = '#F7F7F7';
export var ButtonTertiaryToggleGroupForegroundOff = '#191919';
export var ButtonTertiaryToggleGroupForegroundOffHovered = '#191919';
export var ButtonTertiaryToggleGroupForegroundOffPressed = '#191919';
export var ButtonTertiaryToggleGroupForegroundOffDisabled = '#B2B2B2';
export var ButtonTertiaryToggleGroupBackgroundOn = '#191919';
export var ButtonTertiaryToggleGroupBackgroundOnHovered = '#606060';
export var ButtonTertiaryToggleGroupBackgroundOnPressed = '#494949';
export var ButtonTertiaryToggleGroupBackgroundOnDisabled = '#D6D6D6';
export var ButtonTertiaryToggleGroupBorderOn = '#191919';
export var ButtonTertiaryToggleGroupBorderOnHovered = '#606060';
export var ButtonTertiaryToggleGroupBorderOnPressed = '#494949';
export var ButtonTertiaryToggleGroupBorderOnDisabled = '#D6D6D6';
export var ButtonTertiaryToggleGroupForegroundOn = '#ffffff';
export var ButtonTertiaryToggleGroupForegroundOnHovered = '#ffffff';
export var ButtonTertiaryToggleGroupForegroundOnPressed = '#ffffff';
export var ButtonTertiaryToggleGroupForegroundOnDisabled = '#9F9F9F';
export var ChatIncomingBackground = '#F7F7F7';
export var ChatIncomingForeground = '#191919';
export var ChatOutgoingBackground = '#00838A';
export var ChatOutgoingForeground = '#ffffff';
export var DiagonalDefaultOverlay = '#ffffff';
export var FieldsBackgroundActive = '#F7F7F7';
export var FieldsBackgroundDisabled = '#F7F7F7';
export var FieldsBackgroundError = '#FFF0ED';
export var FieldsBackgroundInactive = '#F7F7F7';
export var FieldsBorderActive = '#191919';
export var FieldsBorderDisabled = '#F7F7F7';
export var FieldsBorderError = '#B71000';
export var FieldsBorderInactive = '#F7F7F7';
export var FieldsForegroundActive = '#191919';
export var FieldsForegroundDisabled = '#B2B2B2';
export var FieldsForegroundError = '#191919';
export var FieldsForegroundInactive = '#191919';
export var FieldsForegroundPlaceholder = '#767676';
export var FieldsIconDropdown = '#191919';
export var FieldsIconSearch = '#191919';
export var FieldsInputBackground = '#ffffff';
export var FieldsInputBackgroundDisabled = '#F7F7F7';
export var FieldsInputBorder = '#D6D6D6';
export var FieldsInputBorderError = '#B71000';
export var GlobalPrimary = '#EB1700';
export var GlobalSecondary = '#00838A';
export var ListCellContainerBackgroundDefault = '#ffffff';
export var ListCellContainerBackgroundHovered = '#F7F7F7';
export var ListCellContainerBackgroundPressed = '#E7E7E7';
export var ListCellContainerBackgroundUnread = '#f4f6fe';
export var ListCellContainerBackgroundUnreadHovered = '#d1dafb';
export var ListCellContainerBackgroundUnreadPressed = '#e6ebfd';
export var ListCellIconToggledOn = '#EB1700';
export var ListCellIconToggledOff = '#494949';
export var LoadingDefault = '#EB1700';
export var MapCurrentLocationBackgroundDefault = '#4969f5';
export var MapCurrentLocationBackgroundOverlay = '#6c87fb';
export var MapCurrentLocationBorder = '#ffffff';
export var MapDasherBackground = '#EB1700';
export var MapDasherForeground = '#ffffff';
export var MapDasherBorder = '#ffffff';
export var MapPinSelectedBackgroundDefault = '#191919';
export var MapPinSelectedBackgroundDisabled = '#B2B2B2';
export var MapPinSelectedForegroundDefault = '#ffffff';
export var MapPinSelectedForegroundDisabled = '#ffffff';
export var MapPinSelectedBorderDefault = '#494949';
export var MapPinSelectedBorderDisabled = '#B2B2B2';
export var MapPinUnselectedBackgroundDefault = '#ffffff';
export var MapPinUnselectedBackgroundDisabled = '#B2B2B2';
export var MapPinUnselectedForegroundDefault = '#191919';
export var MapPinUnselectedForegroundDisabled = '#ffffff';
export var MapPinUnselectedBorderDefault = '#D6D6D6';
export var MapPinUnselectedBorderDisabled = '#B2B2B2';
export var MapPinUnselectedForegroundFood = '#F54323';
export var MapPinUnselectedForegroundCoffee = '#835200';
export var MapPinUnselectedForegroundAlcohol = '#BD8800';
export var MapPinUnselectedForegroundGroceries = '#006A25';
export var MapRoutelineBackgroundDefault = '#191919';
export var MapRoutelineBorder = '#191919';
export var MapRoutelineNodeBackgroundDefault = '#ffffff';
export var MapRoutelineNodeBorder = '#191919';
export var ModalBackground = '#ffffff';
export var OverlayBackgroundDefault = '#191919';
export var OverlayBackgroundLoading = '#ffffff';
export var OverlayLoadingDefault = '#EB1700';
export var PageBackgroundPrimary = '#ffffff';
export var PageBackgroundSecondary = '#F7F7F7';
export var PageBackgroundTertiary = '#E7E7E7';
export var PaginationNumberedNavigationBackground = '#E7E7E7';
export var PaginationNumberedNavigationBackgroundHovered = '#F7F7F7';
export var PaginationNumberedNavigationBackgroundPressed = '#D6D6D6';
export var PaginationNumberedNavigationBackgroundDisabled = '#F7F7F7';
export var PaginationNumberedNavigationBorder = '#E7E7E7';
export var PaginationNumberedNavigationBorderHovered = '#F7F7F7';
export var PaginationNumberedNavigationBorderPressed = '#D6D6D6';
export var PaginationNumberedNavigationBorderDisabled = '#F7F7F7';
export var PaginationNumberedNavigationForeground = '#191919';
export var PaginationNumberedNavigationForegroundHovered = '#191919';
export var PaginationNumberedNavigationForegroundPressed = '#191919';
export var PaginationNumberedNavigationForegroundDisabled = '#B2B2B2';
export var PaginationNumberedSelectedBackground = '#191919';
export var PaginationNumberedSelectedBackgroundDisabled = '#D6D6D6';
export var PaginationNumberedSelectedBackgroundHovered = '#606060';
export var PaginationNumberedSelectedBackgroundPressed = '#494949';
export var PaginationNumberedSelectedBorder = '#191919';
export var PaginationNumberedSelectedBorderDisabled = '#D6D6D6';
export var PaginationNumberedSelectedBorderHovered = '#606060';
export var PaginationNumberedSelectedBorderPressed = '#494949';
export var PaginationNumberedSelectedForeground = '#ffffff';
export var PaginationNumberedSelectedForegroundDisabled = '#9F9F9F';
export var PaginationNumberedSelectedForegroundHovered = '#ffffff';
export var PaginationNumberedSelectedForegroundPressed = '#ffffff';
export var PaginationNumberedUnselectedBackground = '#E7E7E7';
export var PaginationNumberedUnselectedBackgroundDisabled = '#F7F7F7';
export var PaginationNumberedUnselectedBackgroundHovered = '#F7F7F7';
export var PaginationNumberedUnselectedBackgroundPressed = '#D6D6D6';
export var PaginationNumberedUnselectedBorder = '#E7E7E7';
export var PaginationNumberedUnselectedBorderDisabled = '#F7F7F7';
export var PaginationNumberedUnselectedBorderHovered = '#F7F7F7';
export var PaginationNumberedUnselectedBorderPressed = '#D6D6D6';
export var PaginationNumberedUnselectedForeground = '#191919';
export var PaginationNumberedUnselectedForegroundDisabled = '#B2B2B2';
export var PaginationNumberedUnselectedForegroundHovered = '#191919';
export var PaginationNumberedUnselectedForegroundPressed = '#191919';
export var PaginationSelectedDark = '#767676';
export var PaginationSelectedPrimary = '#EB1700';
export var PaginationSelectedLight = '#ffffff';
export var PaginationUnselectedDark = '#D6D6D6';
export var PaginationUnselectedPrimary = '#D6D6D6';
export var PaginationUnselectedLight = '#8B8B8B';
export var PopoverContainerBackground = '#ffffff';
export var RatingSelected = '#E8C500';
export var RatingUnselected = '#E7E7E7';
export var RatingSelectedDisabled = '#B2B2B2';
export var RatingUnselectedDisabled = '#F7F7F7';
export var SliderKnobBackground = '#191919';
export var SliderKnobBackgroundHovered = '#494949';
export var SliderKnobBackgroundPressed = '#313131';
export var SliderKnobBackgroundDisabled = '#D6D6D6';
export var SliderTrackBackgroundOff = '#E7E7E7';
export var SliderTrackBackgroundOffDisabled = '#F7F7F7';
export var SliderTrackBackgroundOn = '#191919';
export var SliderTrackBackgroundOnDisabled = '#D6D6D6';
export var SwitchBackgroundOn = '#191919';
export var SwitchBackgroundOnDisabled = '#D6D6D6';
export var SwitchBackgroundOff = '#ffffff';
export var SwitchBackgroundOffDisabled = '#F7F7F7';
export var SwitchBorderOn = '#191919';
export var SwitchBorderOnDisabled = '#D6D6D6';
export var SwitchBorderOff = '#191919';
export var SwitchBorderOffDisabled = '#B2B2B2';
export var SwitchForegroundOn = '#ffffff';
export var SwitchForegroundOff = '#ffffff';
export var SwitchForegroundOnDisabled = '#F7F7F7';
export var SwitchForegroundOffDisabled = '#ffffff';
export var TagDefaultBackground = '#E7E7E7';
export var TagDefaultForeground = '#191919';
export var TagDefaultIcon = '#191919';
export var TagHighlightBackground = '#00838A';
export var TagHighlightForeground = '#ffffff';
export var TagHighlightIcon = '#ffffff';
export var TagInformationalBackground = '#494949';
export var TagInformationalForeground = '#ffffff';
export var TagInformationalIcon = '#ffffff';
export var TagNegativeBackground = '#B71000';
export var TagNegativeForeground = '#ffffff';
export var TagNegativeIcon = '#ffffff';
export var TagPositiveBackground = '#E7FBEF';
export var TagPositiveForeground = '#006A25';
export var TagPositiveIcon = '#006A25';
export var TagWarningBackground = '#F6E61B';
export var TagWarningForeground = '#191919';
export var TagWarningIcon = '#191919';
export var TagInformationalDefaultBackground = '#E7E7E7';
export var TagInformationalDefaultForeground = '#191919';
export var TagInformationalDefaultIcon = '#191919';
export var TagInformationalEmphasisBackground = '#494949';
export var TagInformationalEmphasisForeground = '#ffffff';
export var TagInformationalEmphasisIcon = '#ffffff';
export var TagNegativeDefaultBackground = '#FFF0ED';
export var TagNegativeDefaultForeground = '#B71000';
export var TagNegativeDefaultIcon = '#B71000';
export var TagNegativeEmphasisBackground = '#B71000';
export var TagNegativeEmphasisForeground = '#ffffff';
export var TagNegativeEmphasisIcon = '#ffffff';
export var TagPositiveDefaultBackground = '#E7FBEF';
export var TagPositiveDefaultForeground = '#006A25';
export var TagPositiveDefaultIcon = '#006A25';
export var TagPositiveEmphasisBackground = '#00872F';
export var TagPositiveEmphasisForeground = '#ffffff';
export var TagPositiveEmphasisIcon = '#ffffff';
export var TagWarningDefaultBackground = '#FFFFA3';
export var TagWarningDefaultForeground = '#835200';
export var TagWarningDefaultIcon = '#835200';
export var TagWarningEmphasisBackground = '#F6E61B';
export var TagWarningEmphasisForeground = '#191919';
export var TagWarningEmphasisIcon = '#191919';
export var TagHighlightDefaultBackground = '#D7F5F5';
export var TagHighlightDefaultForeground = '#00666D';
export var TagHighlightDefaultIcon = '#00666D';
export var TagHighlightEmphasisBackground = '#00838A';
export var TagHighlightEmphasisForeground = '#ffffff';
export var TagHighlightEmphasisIcon = '#ffffff';
export var TextAccentedPrimary = '#EB1700';
export var TextAccentedSecondary = '#00838A';
export var TextAction = '#EB1700';
export var TextCallout = '#EB1700';
export var TextDashpass = '#00838A';
export var TextDisabled = '#B2B2B2';
export var TextError = '#B71000';
export var TextHighlight = '#00838A';
export var TextLink = '#00838A';
export var TextPositive = '#00872F';
export var TextPrimary = '#191919';
export var TextPrimaryOnDark = '#ffffff';
export var TextSecondary = '#494949';
export var TextSecondaryOnDark = '#D6D6D6';
export var TextSelected = '#EB1700';
export var TextTertiary = '#767676';
export var TextTooltip = '#C4C4C4';
export var TextWarning = '#A16C00';
export var TimelineTrackBackgroundOff = '#E7E7E7';
export var TimelineTrackBackgroundOn = '#191919';
export var TimelineTrackForegroundOff = '#191919';
export var TimelineTrackForegroundOn = '#ffffff';
export var TimelineTrackShimmer = '#494949';
export var ToastInformationalBackground = '#313131';
export var ToastInformationalForeground = '#E7E7E7';
export var ToastInformationalAction = '#ffffff';
export var ToastInformationalActionPressed = '#B2B2B2';
export var ToastInformationalActionHovered = '#D6D6D6';
export var ToastInformationalActionDisabled = '#606060';
export var ToggleBackgroundOn = '#191919';
export var ToggleBackgroundOnDisabled = '#D6D6D6';
export var ToggleBackgroundOff = '#ffffff';
export var ToggleBackgroundOffDisabled = '#F7F7F7';
export var ToggleBorderOn = '#191919';
export var ToggleBorderOnDisabled = '#D6D6D6';
export var ToggleBorderOff = '#191919';
export var ToggleBorderOffDisabled = '#B2B2B2';
export var ToggleForegroundOn = '#ffffff';
export var ToggleForegroundOff = '#ffffff';
export var ToggleForegroundOnDisabled = '#F7F7F7';
export var ToggleForegroundOffDisabled = '#ffffff';
export var ToggleBackgroundDisabled = '#D6D6D6';
export var ToggleCheckmarkOn = '#ffffff';
export var ToggleTrackBackgroundDisabled = '#F7F7F7';
export var ToggleTrackBackgroundOff = '#E7E7E7';
export var TooltipHighlightBackground = '#00838A';
export var TooltipHighlightBackgroundHovered = '#00666D';
export var TooltipHighlightBackgroundPressed = '#00494E';
export var TooltipHighlightForeground = '#ffffff';
export var TooltipHighlightForegroundHovered = '#ffffff';
export var TooltipHighlightForegroundPressed = '#ffffff';
export var TooltipInformationalBackground = '#313131';
export var TooltipInformationalBackgroundHovered = '#494949';
export var TooltipInformationalBackgroundPressed = '#606060';
export var TooltipInformationalForeground = '#C4C4C4';
export var TooltipInformationalForegroundHovered = '#D6D6D6';
export var TooltipInformationalForegroundPressed = '#E7E7E7';
export var WarningForeground = '#191919';
export var WarningBackground = '#FEFF58';